import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import ChartV2LineTimeAxis from "./ChartV2LineTimeAxis";
import ChartV2AreaTimeAxis from "./ChartV2AreaTimeAxis";
import ChartV2Columns from "./ChartV2Columns"
import ChartV2ColumnsTimeAxis from "./ChartV2ColumnsTimeAxis"
import ChartV2Pie from "./ChartV2Pie";
import ChartV2ComposedTimeAxis from "./ChartV2ComposedTimeAxis";
import uuid from "react-uuid";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import { Menu, MenuItem } from "@mui/material";
import { tooltip } from "assets/jss/material-dashboard-pro-react.js";
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import zipcelx from 'zipcelx';
import { makeStyles } from "@mui/styles";
import styles from "../../assets/jss/material-dashboard-pro-react/views/chartsStyle";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";
import TimelineIcon from "@mui/icons-material/Timeline";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import { downloadCSV } from "components/ExportTableToCSV/ExportTableToCSV";
import ChartV2Indicator from "./ChartV2Indicator";
import ChartV2Tab from "./ChartV2Tab";
import ChartV2TabEquipment from "./ChartV2TabEquipment";
import ChartV2Heatmap from "./ChartV2Heatmap";
const saveSvgAsPng = require('save-svg-as-png');


const useStyles = makeStyles(styles);
const tooltipStyle = {
    fontSize: '1rem',
    fontFamily: '"Source Sans Pro",sans-serif',
    color: ' #3c4858',
    display: "block", marginTop: "-50px", width: "25rem"
};
const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const menuButtonStyle = {
    float: "right",
    position: "relative",
    marginRight: "-0.5rem",
    paddingTop: "9px",
    fontFamily: '"Source Sans Pro",sans-serif',
};
const cardHeaderStyle = {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
};
const DialogContent = withStyles((theme) => ({
    root: {
        padding: '16px',
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: '8px',
    },
}))(MuiDialogActions);


export default function ChartV2(props) {
    const { chart, data, setData, entityParameters, displayOccupationSchedule } = props;

    return (
        <>

            {
                chart.type === 'linechart' ?
                    <ChartV2LineTimeAxis
                        chart={chart}
                        data={data}
                        setData={setData}
                        entityParameters={entityParameters}
                        displayOccupationSchedule={displayOccupationSchedule}
                    />
                    :
                    chart.type === 'areachart' ?
                        <ChartV2AreaTimeAxis
                            chart={chart}
                            data={data}
                            setData={setData}
                            entityParameters={entityParameters}
                            displayOccupationSchedule={displayOccupationSchedule}
                        />
                        :
                        (chart.type === 'columnchart' && chart.xaxisscale === 'time') ?
                            <ChartV2ColumnsTimeAxis
                                chart={chart}
                                data={data}
                                setData={setData}
                                entityParameters={entityParameters}
                                displayOccupationSchedule={displayOccupationSchedule}
                            /> :
                            (chart.type === 'composedchart' && chart.xaxisscale === 'time') ?
                                <ChartV2ComposedTimeAxis
                                    chart={chart}
                                    data={data}
                                    setData={setData}
                                    entityParameters={entityParameters}
                                    displayOccupationSchedule={displayOccupationSchedule}
                                />

                                :
                                chart.type === 'columnchart' ?
                                    <ChartV2Columns
                                        chart={chart}
                                        data={data}
                                        setData={setData}
                                    />
                                    :
                                    chart.type === 'piechart' ?
                                        <ChartV2Pie
                                            chart={chart}
                                            data={data}
                                            setData={setData}
                                        /> : chart.type === 'indicatorchart' ?
                                            <ChartV2Indicator
                                                chart={chart}
                                                data={data}
                                                setData={setData}
                                            /> : chart.type === 'tab' ?
                                                <ChartV2Tab
                                                    chart={chart}
                                                    data={data}
                                                    setData={setData}
                                                /> : chart.type === 'tabequipment' ?
                                                    <ChartV2TabEquipment
                                                        chart={chart}
                                                        data={data}
                                                        setData={setData}
                                                    /> : chart.type === 'heatmap' ?
                                                        <ChartV2Heatmap
                                                            chart={chart}
                                                            data={data}
                                                            setData={setData}
                                                        /> :
                                                        <></>
            }
        </>
    );
}

function ChartWithCard(props) {
    const classes = useStyles();
    const sweetClasse = UseSweetAlertStyle();
    const [openMenu, setOpenMenu] = React.useState(null);
    // const [state, setState] = React.useState(state);
    const chartRef = React.useRef(null);
    const [alert, setAlert] = React.useState(null);
    const [fullscreen, setFullscreen] = React.useState(false);
    const [data, setData] = useState([]);
    const [displayOccupationSchedule, setDisplayOccupationSchedule] = React.useState(props.chart?.defaultoccupationschedule === 'true' ? true : false);
    const imageOptions = {
        scale: 5,
        encoderOptions: 1,
        backgroundColor: 'white',
    }
    const downloadPng = () => {
        var div1 = document.getElementById(props.uniqueid);
        if (div1)
            saveSvgAsPng.saveSvgAsPng(div1.getElementsByTagName('svg')[0], props.chartTitle + '.png', imageOptions);
        handleClose();
    };

    const downloadCsv = () => {
        if (props.chart.xlsxdata) {
            const link = document.createElement('a');
            let result = "";
            props.chart.xlsxdata.forEach(linearr => {
                let ctr = 0;
                linearr.forEach(column => {
                    if (ctr > 0) result += ";";
                    result += column.value;
                    ctr++;
                });
                result += '\n';
            });
            const filename = props.chartTitle + '.csv';
            if (!result.match(/^data:text\/csv/i)) {
                result = `data:text/csv;charset=utf-8,${result}`;
            }
            link.setAttribute('href', encodeURI(result));
            link.setAttribute('download', filename);
            link.click();
        }
        handleClose();
    };

    const downloadXlsx = () => {
        var div = document.createElement('div');
        div.style.display = 'none';
        document.body.appendChild(div);
        zipcelx({
            filename: props.chartTitle,
            sheet: {
                data: props.chart.xlsxdata
            }
        });
        handleClose();
    };

    const getFullscreen = () => {
        setFullscreen(true);
        handleClose();
    };
    const handleFullscreenClose = () => {
        setFullscreen(false);
    };

    const hideAlert = () => {
        setAlert(null);
    };

    const getTooltipHelp = () => {
        const tooltipAlert = (
            <SweetAlert
                style={tooltipStyle}
                title=""
                onConfirm={() => hideAlert()}
                onCancel={() => hideAlert()}
                confirmBtnCssClass={sweetClasse.button + " " + sweetClasse.info}
            >
                {props.tooltipHelp.split("\n").map((i) => {
                    return <p key={i}>{i}</p>;
                })}
            </SweetAlert>
        );

        setAlert(tooltipAlert);
        handleClose();
    };

    const handleClick = (event) => {
        setOpenMenu(event.currentTarget);
    };

    const handleOccupationSchedule = (event) => {
        setDisplayOccupationSchedule(!displayOccupationSchedule);
        handleClose();
    };

    const handleClose = () => {
        setOpenMenu(null);
    };

    return (
        <div>
            <Card raised={props.simplecard ? false : true} chart style={{ marginTop: '15px', marginBottom: '40px' }}>
                {/* <Card raised={true} chart> */}
                <CardHeader color="success" icon style={cardHeaderStyle}>
                    {props.simplecard ?
                        <></>
                        :
                        <CardIcon color="success" className={classes.cardIcon}>
                            <TimelineIcon />
                        </CardIcon>
                    }
                    <h4 className={props.simplecard ? classes.cardIconTitleSimpleCard : classes.cardIconTitle}>{props.chartTitle}</h4>
                    <div>
                        <Button
                            aria-controls="chart-menu"
                            aria-haspopup="true"
                            onClick={handleClick}
                            justicon={"true"}
                            style={menuButtonStyle}
                        >
                            <MenuIcon />
                        </Button>
                        <Menu
                            id="chart-menu"
                            className={"chart-menu"}
                            anchorEl={openMenu}
                            keepMounted
                            aria-haspopup={'menu'}
                            open={Boolean(openMenu)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={getTooltipHelp} key={`help_chart${Math.random()}`}>
                                Aide sur le graphique{" "}
                            </MenuItem>
                            <MenuItem onClick={getFullscreen} key={`full_${Math.random()}`}>
                                Plein écran
                            </MenuItem>
                            {
                                props.chart.type !== 'tab' ?
                                    <MenuItem onClick={downloadPng} key={`downPng_${Math.random()}`}>
                                        Télécharger en PNG
                                    </MenuItem> : <></>
                            }

                            <MenuItem onClick={downloadXlsx} key={`downCsv${Math.random()}`}>
                                Télécharger en XLSX
                            </MenuItem>
                            <MenuItem onClick={downloadCsv} key={`downCsv${Math.random()}`}>
                                Télécharger en CSV
                            </MenuItem>
                            {
                                (props.entityParameters && props.chart.xaxisscale === 'time' && props.chart.xaxistimetick === 'hour') ?
                                    <MenuItem onClick={handleOccupationSchedule} key={`downCsv${Math.random()}`}>
                                        {displayOccupationSchedule ? "Cacher le planning d'occupation" : "Afficher le planning d'occupation"}
                                    </MenuItem>
                                    :
                                    <></>
                            }
                        </Menu>
                    </div>
                    {alert}
                </CardHeader>

                <CardBody style={props.height ? { height: props.height, userSelect: 'none' } :
                    props.chart.type === 'indicatorchart' ? { minheight: '270px', userSelect: 'none' } :
                        (props.chart.type === 'tab' || props.chart.type === 'tabequipment') ? { userSelect: 'none' } :
                            { height: '370px', userSelect: 'none' }}
                    id={props.uniqueid}>

                    <ChartV2
                        ref={chartRef}
                        chart={props.chart}
                        data={data}
                        setData={setData}
                        entityParameters={props.entityParameters}
                        displayOccupationSchedule={displayOccupationSchedule}
                    />

                </CardBody>
            </Card>
            <Dialog
                onClose={handleFullscreenClose}
                aria-labelledby="edituser-dialog-title"
                fullWidth="true"
                //maxWidth="sm"
                fullScreen={true}
                open={fullscreen}
            >
                <CustomDialogTitle id="customized-dialog-title" onClose={handleFullscreenClose}>
                    {props.chartTitle}
                </CustomDialogTitle>
                <DialogContent dividers>
                    <div style={{ height: "calc(100vh - 120px)", userSelect: 'none', backgroundColor: '#FFFFFF' }}>
                        <ChartV2
                            chart={props.chart}
                            data={data}
                            setData={setData}
                            entityParameters={props.entityParameters}
                            displayOccupationSchedule={displayOccupationSchedule}
                        />
                    </div>
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </div >
    );
}

export const getChartCategoryScriptV2 = (chart, id, entityParameters, simplecard, height) => {
    let displayChart = [];
    let tooltip = chart.tooltip || "Pas de description disponible pour ce graphique";
    let chartwithcard = (<ChartWithCard
        chart={chart} chartTitle={chart.name}
        tooltipHelp={tooltip}
        key={"datachart_" + id}
        uniqueid={"datachart_" + id}
        entityParameters={entityParameters}
        //simplecard={simplecard}
        simplecard={true}
        height={height}
    />);
    displayChart.push(chartwithcard);
    return displayChart;
}